module.exports = __webpack_public_path__ + "img/gps_off.2952131b.svg";